import styles from './PageHeading.module.css'

/** 시안 `.dhead` 이식. 도메인 탭 최상단의 h1 + 영문/모노 부제. */
export type PageHeadingProps = {
  title: string
  sub: string
}

export const PageHeading = ({ title, sub }: PageHeadingProps): JSX.Element => (
  <div className={styles.dhead}>
    <h1 className={styles.h1}>{title}</h1>
    <span className={styles.en}>{sub}</span>
  </div>
)
